module.exports = __webpack_public_path__ + "h5/img/hongka_1.d147a25a.png";